import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

const scrollOnOpen = (isOpening, offset) => {
    if (isOpening) {
        const headerInfo = document.querySelector('.header-info');
        offset['y'] = headerInfo?.getBoundingClientRect().bottom;
    }
    if (offset['y'] > 0) {
        window.scrollTo(0, isOpening ? offset['y'] : -offset['y']);
    }
};

const preventBodyScroll = () => {
    const navbar = document.querySelector('.navbar-nav');
    const navbarCollapse = document.querySelector('#navbar-content');
    const offset = [];

    navbarCollapse.addEventListener('show.bs.collapse', () => scrollOnOpen(true, offset));
    navbarCollapse.addEventListener('shown.bs.collapse', () => disableBodyScroll(navbarCollapse));
    navbarCollapse.addEventListener('hide.bs.collapse', () => {
        enableBodyScroll(navbarCollapse);
        scrollOnOpen(false, offset);
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth >= 992) {
            enableBodyScroll(navbar);
        }
    });
};

const animateNavbar = () => {
    const contactNav = document.querySelector('.navbar-contact');
    const navMain = document.querySelector('.navbar-main');
    const menuNav = document.querySelector('#navbar-content');
    const scrollNav = document.querySelector('.scroll-nav');

    if (! (contactNav && navMain && menuNav && scrollNav)) {
        return;
    }

    const toggleScrollNav = () => {
        const limit = navMain.getBoundingClientRect().bottom - contactNav.getBoundingClientRect().bottom;

        if (limit <= 0) {
            menuNav.classList.add('stick');
            scrollNav.classList.add('show');
        } else {
            menuNav.classList.remove('stick');
            scrollNav.classList.remove('show');
        }
    };

    window.addEventListener('scroll', toggleScrollNav);
    toggleScrollNav();
};

// Note feature removed for https://gitlab.acid.fr/aprosteel/apro-steel.com/-/issues/108
/*const hoverDropdown = () => {
    document.querySelectorAll('.dropdown-mega').forEach((menu) => {
        menu.addEventListener('mouseenter', () => {
            const menuBurger = document.querySelector('.navbar-toggler');
            const canHover = window.getComputedStyle(menuBurger).display === 'none';
            if (canHover && ! menu.querySelector('.show') && menu.querySelector('.dropdown-toggle')) {
                menu.querySelector('.dropdown-toggle').click();
            }
        });
        menu.addEventListener('mouseleave', () => {
            const menuBurger = document.querySelector('.navbar-toggler');
            const canHover = window.getComputedStyle(menuBurger).display === 'none';
            if (canHover && menu.querySelector('.show') && menu.querySelector('.dropdown-toggle')) {
                menu.querySelector('.dropdown-toggle').click();
            }
        });
    });
};*/

export default class Navbar {
    static init() {
        preventBodyScroll();
        animateNavbar();
        //hoverDropdown();
    }
}
